/*
 * @Author: 程序员
 * @Description: 中文包
 * @Date: 2021-07-12 11:12:21
 */
export default {
  message: {
    name: "中文",
  },
};
